module.exports = __webpack_public_path__ + "img/IN.3e4c1905.webp";